// extracted by mini-css-extract-plugin
export default {"inputs":"ReservesDetails_inputs__WrLb0","section":"ReservesDetails_section__xCs8y","section__fields":"ReservesDetails_section__fields__7LsGX"};